import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CameraComponent } from './camera/camera.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { MenubarModule } from 'primeng/menubar';
import { CheckboxModule } from 'primeng/checkbox';
import { WebcamModule } from 'ngx-webcam';
import { PicviewComponent } from './picview/picview.component';
import { PicviewDarkComponent } from './picview/picview-dark.component';
import { EmailComponent } from './email/email.component';
import { DocumentsComponent } from './documents/documents.component';
import { HttpClientModule } from '@angular/common/http';
import { NotesComponent } from './notes/notes.component';
import { MultiplegridComponent } from './multiplegrid/multiplegrid.component';
import { CommonListComponent } from './common-list/common-list.component';
import { NgSelectModule } from '@ng-select/ng-select';
// import { BankListComponent} from './Banks/bankAccount'
import { UserProfileComponent } from './user-profile/user-profile.component';
import { KycPannelComponent } from './kyc-pannel/kyc-pannel.component';
import { NameContactComponent } from './name-contact/name-contact.component';
import { CommunicationComponent } from './communication/communication.component';
import { UserService } from '../services/common/user.service';
import { DocumentFileComponent } from './document-file/document-file.component';
import { UserAddressComponent } from './user-address/user-address.component';
import { AddressDetailComponent } from './address-detail/address-detail.component';
import { CommonTableComponent } from './common-table/common-table.component';
import { CommonTableDarkComponent } from './common-table/dark/common-table-dark.component';
import { TableModule } from 'primeng/table';
import { TreeTableModule } from 'primeng/treetable';
import { SidebarModule } from 'primeng/sidebar';
import { CommonFormComponent } from './common-form/common-form.component';
import { CommonExportComponent } from './common-export/common-export.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ExportComponent } from './export/export.component';
import { EnumToArrayPipe } from './export/export.pipe';
import { CompanyService, DocumentsService } from '../services/common';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { BankAccountAddComponent } from './Banks/bankAccount/bank-account-add/bankAccount-add.component';
import { BankListComponent } from './Banks/bankAccount/bank-account-list/bank-list.component';
import { BankAccountComponent } from './Banks/bankAccount/bankAccount.component';
import { PlainMapviewComponent, GmapViewComponent } from './google-map';
import { CommonMapComponent } from './common-map/common-map.component';
import { CommonChartComponent } from './common-chart/common-chart/common-chart.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { FarmerDetailsComponent } from '../main-layout/acquisition/farmer/farmer-details/farmer-details.component';
import { KhasraDetailsComponent } from '../main-layout/acquisition/khasra/khasra-details/khasra-details.component';
import { ClientDetailsComponent } from '../main-layout/sales/client/client-details/client-details.component';
import { UserProfilePicComponent } from './user-profile/user-profile-pic/user-profile-pic.component';
import { DynamicChartComponent } from './common-chart/dynamic-chart/dynamic-chart.component';
import { SharedModule } from '../shared/shared.module';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TooltipModule } from 'primeng/tooltip';
import { DocumentUploadWizardModule } from './document-upload-wizard/document-upload-wizard.module';
import { ExpandFullscreenDirective } from './directives/expand-fullscreen.directive';
import { KmlUploadComponent } from './kml-upload';
import { DocumentViewComponent } from './document-view/document-view.component';

@NgModule({
  declarations: [
    CameraComponent,
    PicviewComponent,
    PicviewDarkComponent,
    DocumentsComponent,
    EmailComponent,
    NotesComponent,
    MultiplegridComponent,
    CommonListComponent,
    BankListComponent,
    BankAccountAddComponent,
    BankAccountComponent,
    UserProfileComponent,
    KycPannelComponent,
    NameContactComponent,
    CommunicationComponent,
    DocumentFileComponent,
    AddressDetailComponent,
    UserAddressComponent,
    CommonTableComponent,
    CommonTableDarkComponent,
    CommonFormComponent,
    CommonExportComponent,
    ExportComponent,
    PlainMapviewComponent,
    GmapViewComponent,
    CommonMapComponent,
    ConfirmDialogComponent,
    CommonChartComponent,
    DynamicChartComponent,
    UnauthorizedComponent,
    FarmerDetailsComponent,
    KhasraDetailsComponent,
    ClientDetailsComponent,
    UserProfilePicComponent,
    ExpandFullscreenDirective,
    KmlUploadComponent,
    DocumentViewComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    DropdownModule,
    MenubarModule,
    CheckboxModule,
    WebcamModule,
    HttpClientModule,
    NgSelectModule,
    TableModule,
    TreeTableModule,
    SidebarModule,
    RadioButtonModule,
    InputSwitchModule,
    TooltipModule,
    EnumToArrayPipe,
    CalendarModule,
    NgApexchartsModule,
    SharedModule,
    DocumentUploadWizardModule
  ],
  providers: [UserService, DocumentsService, CompanyService],

  exports: [
    CommonModule,
    WebcamModule,
    CameraComponent,
    DocumentsComponent,
    CommonListComponent,
    BankAccountAddComponent,
    BankListComponent,
    UserProfileComponent,
    KycPannelComponent,
    CommunicationComponent,
    DocumentFileComponent,
    NameContactComponent,
    BankAccountComponent,
    UserAddressComponent,
    AddressDetailComponent,
    CommonTableComponent,
    CommonTableDarkComponent,
    CommonFormComponent,
    PicviewComponent,
    PicviewDarkComponent,
    PlainMapviewComponent,
    CommonMapComponent,
    ExportComponent,
    ConfirmDialogComponent,
    CommonChartComponent,
    DynamicChartComponent,
    UnauthorizedComponent,
    FarmerDetailsComponent,
    KhasraDetailsComponent,
    ClientDetailsComponent,
    UserProfilePicComponent,
    KmlUploadComponent,
    DocumentUploadWizardModule,
    ExpandFullscreenDirective,
    TooltipModule,
    DocumentViewComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: []
})

export class CommoncomponentsModule { }
